import React, { useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Pagination from '@material-ui/lab/Pagination';
import PaginationItem from '@material-ui/lab/PaginationItem';
import TextField from '@material-ui/core/TextField';
import useDeviceDetection from '../../hooks/deviceIntegration/useDeviceDetection';
import SarasTooltip from '../../notifications/SarasTooltip';
import { InputAdornment } from '@material-ui/core';


const useStyles = makeStyles((theme) => ({
  root: {},
  ul: { justifyContent: 'center' },
  pageItem: { color: '#333', backgroundColor: '#fff', marginRight: '4px',
    '&:hover': {
        backgroundColor: `#fff !important`,  
        color: `${theme.palette.secondary.main} !important`,
    }
  },
  pageElips: { color: '#110b0bff', fontWeight: 'bold', fontSize: '16px'  },
  pageIcon: {
    fontSize: '1.4rem !important',   // <— your desired size
  },
  hover: { backgroundColor: `${theme.palette.secondary.main} !important`, color: '#fff !important' },
  selected: { backgroundColor: `${theme.palette.secondary.main} !important`, color: '#fff !important' },
  container: { display: 'flex', alignItems: 'center', gap: 8 },
 ofLabel: { color: '#555', fontSize: 12 }
}));

const SarasPaging2 = (props) => {
  //hidePageIfNR : hide page numbers if only one page or less
  const { onPageChange, paging, goTop, showPageJump = true, hidePageIfNR = false } = props;
  const [currPage, setCurrPage] = React.useState(1);
  const [draftPage, setDraftPage] = React.useState('1');
  const classes = useStyles();
  const deviceInfo = useDeviceDetection();

  const changePage = (page) => {
    if (goTop) window.scrollTo({ top: 0, left: 0 });
    if (paging.firstPage <= page && page <= paging.lastPage){
      setCurrPage(page);
      onPageChange(page);
    }
  };

  const commitDraft = () => {
    let n = parseInt(draftPage, 10);
    if (isNaN(n)) { setDraftPage(String(currPage)); return; }
    n = Math.min(Math.max(n, paging.firstPage), paging.lastPage);
    if (n !== currPage) changePage(n);
    else setDraftPage(String(currPage));
  };

  const onCurrPageChange = (e, value) => {
    if (value !== paging.currentPage) changePage(value);
  };

    // console.log("paging props", props);
    const initializeCurrPage = () => {
        setCurrPage(paging.currentPage)
    }
    useEffect(initializeCurrPage, [paging]);

    useEffect(() => { setDraftPage(String(currPage)); }, [currPage]);

    const hidePageNumbers = deviceInfo.isMobileWidth 
                            || deviceInfo.isTabletWidth 
                            || deviceInfo.isMobile 
                            || deviceInfo.isTablet;

    const renderPageJump = () => {
      if(!showPageJump) return null;

      return (
          <SarasTooltip title="Key the page number and then press tab or enter">
              <TextField
              type="text"
              variant="standard"
              size="small"
              margin="none"
              value={draftPage}
              onChange={(e) => setDraftPage(e.target.value)}
              onKeyDown={(e) => { if (e.key === 'Enter') commitDraft(); }}
              onBlur={commitDraft}
              inputProps={{
                  inputMode: 'numeric',     // mobile numeric keypad
                  pattern: '[0-9]*',
                  'aria-label': 'Jump to page',
                  style: { textAlign: 'center' }
              }}
              className='uiPagingJump'
              InputProps={{
                  disableUnderline: true,
                  classes: {
                  root: 'uiPagingFieldRoot',
                  input: 'uiPagingFieldInput',
                  },
                  endAdornment: (
                  <InputAdornment position="end" disablePointerEvents 
                      className='uiPagingAdornment'
                      style={{ whiteSpace: 'nowrap' }}>
                      / {paging.totalPages} {'p'}
                  </InputAdornment>
                  )
              }}
              />
          </SarasTooltip>
        )
    }
    
    if(!paging || (hidePageIfNR && paging.totalPages <= 1))
      return null;

    return (
        <div className="uiFlexBox uiPagingContainer">
            <Pagination count={paging.totalPages} disabled={paging.totalPages === 1} 
                page={currPage} onChange={onCurrPageChange} size="small"
                variant="outlined" shape="rounded"
                color="secondary"
                classes={{
                    ul: classes.ul,
                }}
                // This prop applies the custom style to the selected page
                renderItem={(item) => {
                    if (item.type === 'previous' 
                            || item.type === 'next') {
                        return (<PaginationItem
                            {...item}
                            classes={{
                                root: classes.pageItem,
                                selected: classes.selected,  // selected
                                icon: classes.pageIcon,
                            }}
                        />);
                    }
                    else if (!showPageJump) {
                      if (!hidePageNumbers) {
                          return (<PaginationItem
                              {...item}
                              classes={{
                                  root: item.type === 'start-ellipsis' || item.type === 'end-ellipsis' ? classes.pageElips : classes.pageItem,
                                  selected: classes.selected,  // selected
                              }}
                          />);
                      }
                      else if (item.page === currPage) {
                          return (
                            <span
                                key={item.page}
                                style={{
                                    display: 'inline-block',
                                    textAlign: 'center',
                                    fontWeight: 'bold',
                                    color: '#333',
                                    margin: '5px',
                                }}
                            >
                                {currPage}
                            </span>
                        );
                      }
                    }

                    return null;
                }}

            />
            {renderPageJump()}
          </div>
    );
}

export default SarasPaging2;
